import Icon from 'components/Icon';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function InnerLinkHelper({
  href,
  label,
  noSidePadding
}: {
  href: string;
  label: string;
  noSidePadding?: boolean;
}) {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1040);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1040);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <span className="typography">
      <Link
        to={href}
        target="_blank"
        style={{
          position: 'absolute',
          top: '1.2rem',
          right: noSidePadding ? 0 : 'var(--gap-S)',
          zIndex: 100
        }}
      >
        {isSmallScreen ? <Icon name="pen" /> : label}
      </Link>
    </span>
  );
}
